import { Box, Flex, Text } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';
import Icon from '~/components/Icon';

const DropZone = styled(Flex)`
  border-radius: var(--radius-4);
  border: 1px dashed var(--gray-a8);
`;

const IconBox = styled(Box)`
  border-radius: var(--radius-4);
  border: 1px solid var(--gray-4);
`;

const FileInput = styled.input`
  width: 175px;
`;

function DragAndDropUploadFile({ onFile, allowedMimeTypes, allowedExtensions, fileTitle = 'file' }) {
  const [isOverZone, setIsOverZone] = useState(false);

  return (
    <DropZone
      direction='column'
      align='center'
      justify='center'
      p='2'
      width='100%'
      minHeight='240px'
      onDrop={e => {
        e.preventDefault();
        const isFile = e.dataTransfer.items[0].kind !== 'file';
        const isCorrectFileType = allowedMimeTypes.includes(e.dataTransfer.items[0].type);
        const isInputInvalid = !isFile && !isCorrectFileType;
        if (isInputInvalid) {
          setIsOverZone(false);
          return;
        }

        onFile(e.dataTransfer.items[0].getAsFile());
      }}
      onDragOver={e => {
        e.preventDefault();
        setIsOverZone(true);
      }}
      onDragLeave={e => {
        e.preventDefault();
        setIsOverZone(false);
      }}
    >
      <Flex
        direction='column'
        align='center'
        justify='center'
        gap='4'
      >
        <IconBox
          asChild
          height='40px'
          width='40px'
        >
          <Flex
            align='center'
            justify='center'
          >
            <Icon
              name='upload-01'
              width={16}
              height={16}
              inline
              color='var(--gray-12)'
            />
          </Flex>
        </IconBox>
        <Flex
          gap='2'
          direction='column'
          align='center'
          justify='center'
        >
          <Text
            size='3'
            weight='bold'
          >
            Upload {fileTitle}
          </Text>
          <Text size='2'>
            {isOverZone
              ? `Drop ${allowedExtensions.join(', ')} file here to upload`
              : `Drag and drop ${allowedExtensions.join(', ')} file here to upload`}
          </Text>
          <Text size='2'>or</Text>
          <FileInput
            type='file'
            name='data'
            accept={allowedMimeTypes.join(', ')}
            onChange={e => onFile(e.target.files[0])}
          />
        </Flex>
      </Flex>
    </DropZone>
  );
}

DragAndDropUploadFile.propTypes = {
  onFile: PropTypes.func,
  allowedMimeTypes: PropTypes.arrayOf(PropTypes.string),
  allowedExtensions: PropTypes.arrayOf(PropTypes.string),
  fileTitle: PropTypes.string,
};

export default DragAndDropUploadFile;
